export const COMPANY_SETTINGS_TAG_TYPE = 'CompanySettings';
export const USER_SETTINGS_TAG_TYPE = 'UserSettings';

export const COMPANY_SETTINGS_IDS = {
  ASP_SETTINGS: 'asp_settings',
  ACTIVITY_CATEGORY_ENABLED: 'activity_category_enabled',
  ACTIVITY_CATEGORY_LABEL: 'activity_category_label',
  PLAY_SUMMARIES_ENABLED: 'play_summaries_enabled',
};
